import { useContext } from 'react';
import MetricsInspectionContext from '../../state/context';
import { ACTIVITY_TYPES } from '../../state/state.utils';
import useBranchesLayout from './useBranchesLayout/useBranchesLayout';
import usePRsLayout from './usePRsLayout/usePRsLayout';

const mapActivityTypeToTableLayout = {
  [ACTIVITY_TYPES.BRANCHES]: useBranchesLayout,
  [ACTIVITY_TYPES.PRS]: usePRsLayout
};

const useTableLayout = ({ data }) => {
  const {
    state: {
      filters: { activityType }
    }
  } = useContext(MetricsInspectionContext);

  const useCustomTableLayout = mapActivityTypeToTableLayout[activityType];
  const tableLayout = useCustomTableLayout?.({ data });

  return tableLayout || {};
};

export default useTableLayout;
